import { useEffect } from 'react'
import { CoursePreviewModal } from '@/components/dialogs/course-preview-modal'
import { Modal } from '@/components/dialogs/modal'
import { TextInput } from '@/components/inputs/text-input'
import { SimpleTable } from '@/components/tables/simple-table'
import { Button } from '@/components/ui/button'
import type { Curriculum } from '@/types/courses/curriculum'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'
import { useChooseCurriculum } from './hooks/use-choose-curriculum'

interface ChooseCurriculumProps {
  currentCurriculum?: Curriculum
  setCurrentCurriculum?: (curriculum: Curriculum) => void
  curriculums?: Curriculum[]
  disabled?: boolean
  formMethods?: StudentRequestedCoursesFormMethods
}

export const ChooseCurriculum = ({
  currentCurriculum,
  curriculums,
  disabled,
  formMethods,
  setCurrentCurriculum
}: ChooseCurriculumProps) => {
  const {
    states: {
      isOpen,
      selectedCurriculums,
      previewOpen,
      searchText,
      tableConfig,
      previewCurriculumId
    },
    actions: {
      setOpen,
      setSelectedCurriculums,
      setPreviewOpen,
      handleSearchInput
    }
  } = useChooseCurriculum(curriculums)

  const selectCurriculum = () => {
    if (selectedCurriculums.length > 0) {
      if (setCurrentCurriculum && formMethods && formMethods.setValue) {
        setCurrentCurriculum(selectedCurriculums[0])
        formMethods.setValue('curriculum', selectedCurriculums[0].id)
      }
    }
    setOpen(false)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (currentCurriculum) {
      setSelectedCurriculums([currentCurriculum])
    }
  }, [currentCurriculum])

  return (
    <>
      <Button
        type="button"
        disabled={disabled}
        onClick={() => setOpen(!isOpen)}
        variant={'light'}
      >
        <p className="text-[var(--brand-blue-3)] font-bold">Trocar currículo</p>
      </Button>

      <Modal
        backButtonLabel="Voltar"
        submitButtonLabel="Selecionar"
        title={`Currículo: ${currentCurriculum?.curriculumID || currentCurriculum?.id}`}
        isOpen={isOpen}
        description="Selecione um currículo disponível"
        setOpen={setOpen}
        className="sm:max-w-none w-250"
        submitButtonDisabled={
          selectedCurriculums && selectedCurriculums.length === 0
        }
        submitAction={selectCurriculum}
      >
        <p className="font-bold mt-2 mb-4">
          Selecione o currículo de melhor aproveitamento para o aluno
        </p>
        <TextInput
          onChange={handleSearchInput}
          className="bg-input/40 h-10 mb-2"
          placeholder="Pesquise"
          value={searchText}
        />
        <div className="w-full h-100 overflow-y-auto">
          <SimpleTable
            tableConfig={tableConfig}
            selectable={true}
            selectedItems={selectedCurriculums}
            setSelectedItems={setSelectedCurriculums}
            selectableMax={1}
          />
        </div>
      </Modal>
      <CoursePreviewModal
        isOpen={previewOpen}
        setOpen={setPreviewOpen}
        curriculum={previewCurriculumId}
        title={currentCurriculum?.curriculumID || ''}
      />
    </>
  )
}
